/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPublicDataBaseStatistics
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPublicDataBaseStatistics = FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions;

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseStatistics {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseStatistics {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSON(value as FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions);
    }

    return {};
}

